import {AddVatCalculator} from './components/calcAddVat';
import {ComputeSumCalculator} from './components/calcComputeSum';
import {HighlightVatCalculator} from './components/calcHighlightVat';

$(function () {
    let addVatCalculator = new AddVatCalculator();
    let computeSumCalculator = new ComputeSumCalculator();
    let highlightVatCalculator = new HighlightVatCalculator();
    computeSumCalculator.isActive = false;
    highlightVatCalculator.isActive = false;

    const tooltipDiv1 = $("#tooltipDiv1");
    const tooltipDiv2 = $("#tooltipDiv2");

    function changeTab() {
        $(".calc-div-input-tabs div.selected").removeClass('selected');
        $(this).addClass('selected');
 
        var calcType = $('.calc-div-input-tabs div.selected').data('type');
        let inputTitle = "";
        if(calcType == 1){
            addVatCalculator.isActive = true;
            computeSumCalculator.isActive = false;
            highlightVatCalculator.isActive = false;
            addVatCalculator.autoSubmit(null, true);
            inputTitle = addVatCalculator.inputTitle;
        }else if(calcType == 2){
            addVatCalculator.isActive = false;
            computeSumCalculator.isActive = false;
            highlightVatCalculator.isActive = true;
            highlightVatCalculator.autoSubmit(null, true);
            inputTitle = highlightVatCalculator.inputTitle;
        }else{
            addVatCalculator.isActive = false;
            computeSumCalculator.isActive = true;
            highlightVatCalculator.isActive = false;
            computeSumCalculator.autoSubmit(null, true);
            inputTitle = computeSumCalculator.inputTitle;
        }

        $('#sumInputTitle, #inputSumTitle').html(inputTitle);

        if (calcType === 2) {
           $("#calculatedRate").show();
           $("#fixedRate").hide();
           $("#rateBlock dropdown-select").show();
           $("#rateDroplist").hide();
           if($("#rateBlock dropdown-select").val() === 0) {
            tooltipDiv1.show();
            tooltipDiv2.hide();
           } else {
            tooltipDiv1.hide();
            tooltipDiv2.show();
           }
           
        } else {
            $("#rateBlock").removeClass("calculated-rate")
            $("#calculatedRate").hide();
            $("#fixedRate").show();
            $(".hardcoded-vat-rates.fixed-rates").show();
            $(".hardcoded-vat-rates.calculated-rates, .hardcoded-vat-rates.calculated-decimal-rate").hide();
            $("#rateBlock dropdown-select").hide();
            $("#rateDroplist").show();
            tooltipDiv1.show();
            tooltipDiv2.hide();
        } 
    
        
    }
    $(".calc-div-input-tabs div.calc-div-input-tab").click(changeTab);
    
});